import { HTMLInputTypeAttribute } from "react";
import { UseFormRegister, FieldValues, Path, FieldErrors, RegisterOptions } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { translationKey } from "../i18n";

export const Input = <TFIeldValues extends FieldValues, TProperty extends Path<TFIeldValues>>({
	register,
	name,
	errors,
	label,
	placeholder,
	registerOptions,
	inputType = "text",
	required = false,
	readOnly = false
}: {
	register: UseFormRegister<TFIeldValues>;
	name: TProperty;
	errors: FieldErrors<TFIeldValues>;
	label: translationKey;
	placeholder?: translationKey;
	registerOptions?: RegisterOptions<TFIeldValues, TProperty>;
	inputType?: HTMLInputTypeAttribute;
	required?: boolean;
	readOnly?: boolean;
}) => {
	const { t } = useTranslation();
	const fieldError = errors[name]?.message as string | undefined;

	return (
		<div className={`form-group ${errors[name] ? "has-error" : ""}`}>
			<label>
				{t(label)}
				{required || registerOptions?.required ? " *" : ""}
			</label>
			<input
				{...register(name, {
					...(required && { required: t("requiredField") }),
					...registerOptions
				})}
				type={inputType}
				placeholder={placeholder ? t(placeholder) : undefined}
				className="form-control"
				readOnly={readOnly}
			/>
			{fieldError && <div className="help-block">{fieldError}</div>}
		</div>
	);
};
